import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Alert, Stack, Typography } from '@mui/material';

import { type ExperimentalFeatureKey, experimentalFeatures } from '@luxuryescapes/contract-svc-promo';

import isProd from '~/utils/isProd';

import DebugModal from '../DebugModal/DebugModal';

interface Props {
  featureKey: ExperimentalFeatureKey;
}

export default function ExperimentalFeatureNotice({ featureKey }: Props) {
  const feature = experimentalFeatures.find((item) => item.key === featureKey);

  if (!feature) {
    return null;
  }

  const isUnavailableTestFeature = feature.isOnlyTest && isProd();

  return (
    <Alert severity={isUnavailableTestFeature ? 'warning' : 'info'} variant="outlined" sx={{ py: 0 }}>
      <Accordion disableGutters elevation={0} sx={{ backgroundColor: 'transparent' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 0 }}>
          <Typography variant="body2">Experimental feature – {feature.currentStatusHeadline}.</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ px: 0 }}>
          <Stack spacing={1}>
            <Typography variant="body2">{feature.description}</Typography>
            <Typography variant="body2" color="text.secondary">
              Status: {feature.experimentalStatus}.
            </Typography>
            <DebugModal
              type="generic"
              title={`${feature.displayName} configuration`}
              data={feature}
              buttonProps={{ size: 'small', variant: 'text' }}
            >
              Debug modal
            </DebugModal>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Alert>
  );
}
